import { getNamedDates } from 'services/utils';

/**
 * Edições da campanha Joga Junto & Simplifique, com o período de cada regulamento.
 *
 * É a fonte única de duas decisões que precisam andar juntas: se o ciclo tem campanha (card da home
 * e aba "Campanhas" dos desafios) e qual prazo as duas telas anunciam. O prazo é o do regulamento,
 * e não o do ciclo: o 2S2026 vai de 11/08/2026 a 05/02/2027, a edição vai de 01/07 a 31/12/2026.
 *
 * Uma edição nova entra aqui; sem ela, os ciclos depois do fim da última edição ficam sem campanha.
 */
export type EdicaoSimplifique = {
  /** `date_start` do ciclo em que a edição começa a valer. */
  inicioDoCiclo: number;
  /** Último instante da edição: 23:59:59.999 de Brasília do último dia (regulamento, 5.2). */
  fim: number;
  /** Primeiro dia do período, por extenso: `'01 de julho'`. */
  primeiroDia: string;
  /** Último dia do período, por extenso e com ano: `'31 de dezembro de 2026'`. */
  ultimoDia: string;
};

function edicoes(): EdicaoSimplifique[] {
  const dates = getNamedDates();

  return [
    {
      inicioDoCiclo: dates.ciclo_2S2025,
      fim: 1767236399999, // 31/12/2025 23:59:59.999 (Brasília)
      primeiroDia: '01 de julho',
      ultimoDia: '31 de dezembro de 2025',
    },
    {
      inicioDoCiclo: dates.ciclo_1S2026,
      fim: 1782874799999, // 30/06/2026 23:59:59.999 (Brasília)
      primeiroDia: '02 de janeiro',
      ultimoDia: '30 de junho de 2026',
    },
    {
      inicioDoCiclo: dates.ciclo_2S2026,
      fim: 1798772399999, // 31/12/2026 23:59:59.999 (Brasília)
      primeiroDia: '01 de julho',
      ultimoDia: '31 de dezembro de 2026',
    },
  ];
}

/**
 * A edição que vale para o ciclo que começa em `cycleStartDate`: a última cujo ciclo começa antes
 * ou junto com ele, desde que o ciclo comece antes do fim dela. Sem ciclo, ou fora de qualquer
 * edição, devolve `undefined`.
 */
export function edicaoSimplifiqueDoCiclo(cycleStartDate?: number): EdicaoSimplifique | undefined {
  if (typeof cycleStartDate !== 'number') return undefined;

  const edicao = edicoes()
    .filter(item => item.inicioDoCiclo <= cycleStartDate)
    .pop();

  return edicao && cycleStartDate <= edicao.fim ? edicao : undefined;
}
